import { CommonModule } from '@angular/common';
import { afterNextRender, ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { lastValueFrom } from "rxjs";
import { DocumentLineItemSerialLinkSearchInput, Operator, SearchInput, SortOrder } from "../../../../generated/generated-types";
import { DocumentLineItemService } from "../../services/document-line-item.service";

@Component({
  selector: 'app-formly-line-item-serial-detail',
  templateUrl: './formly-line-item-serial-detail.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TranslatePipe,
  ]
})
export class FormlyLineItemSerialDetailComponent extends FieldType {
  private readonly dliService = inject(DocumentLineItemService);

  serialNumbers = signal<string[]>([]);

  /** @description total number of serial numbers for this dli. 
   * @note if -1 then we dont know (should only be the case for outbound serials) */
  totalSerialNumberCount = signal<number>(0);

  loading = signal<boolean>(false);

  constructor(
  ) {
    super();

    afterNextRender(() => {
      if (!this.model?.id || !this.model?.product) {
        // untracked(() => this.serialNumbers.set([]));
        this.serialNumbers.set([]);
        this.totalSerialNumberCount.set(0);
      }
      else
        this.getData();
    });
  }

  getData(take = -1) {

    if (!(this.model.product))
      return;

    if (take == -1)
      take = 1000; //find a better solution, otherwise this may need to be increased

    let baseSi: SearchInput = {
      take: take,
      sort: [{ field: "serialNumber", order: SortOrder.ASC }],
      searchFilter: {
        rules: [
          {
            field: "serialNumber",
            operator: Operator.isnotnull
          },
          {
            field: "serialNumber",
            operator: Operator.notequal,
            value: ""
          },
          {
            field: "deleted",
            operator: Operator.equal,
            value: "false"
          }
        ]
      }
    }

    if (this.model.product.inventoryTrackingType == "SERIAL"
      || this.model.product.inventoryTrackingType == "OUTBOUNDSERIAL") {
      let si: DocumentLineItemSerialLinkSearchInput = {
        ...baseSi,
        documentLineItemIds: [this.model.id]
      };

      this.loading.set(true);
      lastValueFrom(this.dliService.getDocumentLineItemSerialLinks(si))
        .then(x => {
          this.totalSerialNumberCount.set(x?.length == take ? -1 : (x?.length ?? 0));
          let items = x
            ?.filter(x => x.serialNumber)
            ?.map(x => x.serialNumber);

          this.serialNumbers.set(items);
          this.loading.set(false);
        }).catch(e => {
          console.error(e);
          this.loading.set(false);
        });
    }
  }
}
